import React, { useEffect, useState } from 'react';
import SalaryReportsPage from './SalaryReportsPage';
import { organizationAPI } from '../lib/api';

const BLOGIC_NAME_MATCH = 'blogic';

/**
 * Blogic Salary Entry — dedicated module that locks SalaryReportsPage
 * to Blogic Software Technology Pvt Ltd's organization_id.
 * Same UI/calculation as the regular Salary Reports page, just scoped to one org.
 */
export default function BlogicSalaryEntryPage() {
  const [orgId, setOrgId] = useState(null);
  const [orgName, setOrgName] = useState('Blogic');
  const [error, setError] = useState(null);

  useEffect(() => {
    organizationAPI.getAll().then(res => {
      const blogic = (res.data || []).find(o =>
        (o.name || '').toLowerCase().includes(BLOGIC_NAME_MATCH)
      );
      if (blogic) {
        setOrgId(blogic.id);
        setOrgName(blogic.name);
      } else {
        setError('Blogic organization not found. Create an organization with "Blogic" in its name.');
      }
    }).catch(() => setError('Failed to load organizations'));
  }, []);

  if (error) {
    return (
      <div className="p-8 text-center text-sm text-red-600" data-testid="blogic-not-found">
        {error}
      </div>
    );
  }
  if (!orgId) return null;

  return (
    <SalaryReportsPage
      lockedOrganizationId={orgId}
      lockedOrganizationName={orgName}
    />
  );
}
